import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HttpService from '../services/HttpServices';

const apiService = HttpService;

const initialState = {
    data: [],
    totalRecords: 0,
    loading: false,
    error: false
}


export const fetchAllBanners = createAsyncThunk(
    'banners',
    async (queryParams, thunkAPI) => {
        try {
            const response = await apiService.get('/banners',
                { params: queryParams },
            );
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data || error.message);
        }
    }
)

export const fetchCompanyBanners = createAsyncThunk(
    'companyBanners',
    async (queryParams, thunkAPI) => {
        try {
            const response = await apiService.get('/banners?type=company');
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data || error.message);
        }
    }
)


export const bannerSlice = createSlice({
    name: "banners",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllBanners.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAllBanners.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
                state.totalRecords = action.payload.totalRecords // This is your response.data.data
            })
            .addCase(fetchAllBanners.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Ensure this is in a usable format
            })
            .addCase(fetchCompanyBanners.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchCompanyBanners.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
                state.totalRecords = action.payload.totalRecords // This is your response.data.data
            })
            .addCase(fetchCompanyBanners.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Ensure this is in a usable format
            })
    }
})

export default bannerSlice.reducer;